import { Box, Button, HStack, IconProps, Stack } from '@chakra-ui/react'
import Link from 'next/link'
import { FC, ReactNode } from 'react'

import DollarCircle from '../../svg/DollarCircle'
import { H2, H6, Label } from '../../typography'
import { onlineSolutionsData } from './onlineSolutionsData'

interface OnlineSolutionsSectionProps {
  callToAction?: ReactNode
  itemsList?: { icon: FC<IconProps>; text: string }[]
}

const OnlineSolutionsSection: FC<OnlineSolutionsSectionProps> = ({ callToAction, itemsList = onlineSolutionsData }) => {
  return (
    <Box bg="grayscale.20">
      <Stack
        direction={{ base: 'column', lg: 'row' }}
        maxW="1280px"
        mx="auto"
        px={6}
        gap={{ base: '40px', lg: '28px' }}
      >
        <Stack flex="1" gap={{ base: '32px', lg: '48px' }} pt={{ base: '52px', lg: '128px' }}>
          {callToAction ?? (
            <>
              <H2>A solução online para saúde masculina mais completa do Brasil</H2>

              <Link prefetch={false} href="/consultar" passHref>
                <Button
                  _hover={{
                    bg: 'yellow.60'
                  }}
                  bg="dandelion"
                  boxShadow="none"
                  size="lg"
                  minH="48px"
                  rounded="full"
                  w="max-content"
                >
                  <Label color="phthalo">Comece um tratamento</Label>
                </Button>
              </Link>
            </>
          )}
        </Stack>

        <Stack
          flex="1"
          pt={{ base: 0, lg: '128px' }}
          pb={10}
          gap={{ base: 4, lg: 6 }}
          maxW={{ base: '400', lg: 'none' }}
          mx="auto"
        >
          {itemsList.map((item, index) => (
            <Card key={index} {...item} />
          ))}
        </Stack>
      </Stack>
    </Box>
  )
}

export default OnlineSolutionsSection

interface CardProps {
  icon?: any
  text: string
}

const Card: FC<CardProps> = ({ icon, text }) => {
  return (
    <HStack
      bg="alabaster"
      borderRadius={{ base: '24px', lg: '40px' }}
      px={{ base: 4, lg: '64px' }}
      py={{ base: 6, lg: '40px' }}
      gap={{ base: 2, lg: '32px' }}
    >
      <Box boxSize={{ base: 6, lg: '40px' }} as={icon || DollarCircle} strokeWidth={3} color="phthalo"></Box>
      <H6>{text}</H6>
    </HStack>
  )
}
